import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full flex items-center gap-1" }

import { useStore } from "vuex";
import { AxiosInstance } from "axios";
import { inject, ref } from "vue";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'ShowUpline',
  props: ["data", "type"],
  setup(__props) {



const store = useStore();
const router = useRouter();
const axios = inject("$axios") as AxiosInstance;
const showUpline = ref(false);
const upline = ref({ username: "", userId: undefined });

const checkNameColumn = (column: any) => {
  if (column.gameId === undefined) {
    return column.userName;
  } else return column.gameId;
};

const goToProfile = async (userName: string) => {
  try {
    const profile = await getUserInfo(userName);
    window.open(`/players/${profile.data[0].id}`, '_blank');
    // router.push(`/players/${profile.data[0].id}`);
  } catch (error) {
    alert("ไม่พบข้อมูลผู้ใช้งาน");
  }
};

const getUpline = async (userName: string) => {
  try {
    if (showUpline.value) {
      showUpline.value = false;
    } else {
      const profile = await getUserInfo(userName);

      if (!profile.data.length) {
        alert("ไม่พบข้อมูลหัวสาย");
        return;
      }

      const uplineData = await axios
        .post(
          `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/cms/customers/get-referral`,
          {
            operator_id: store.state.selectedOperator.operatorId,
            user_id: profile.data[0].id,
          }
        )
        .then((res) => res.data);

      if (uplineData.username) {
        upline.value = uplineData;
      } else {
        upline.value.username = "";
      }

      showUpline.value = true;
    }
  } catch (error) {
    upline.value.username = "";
  }
};

const getUserInfo = async (username: string) => {
  const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/operator-admin/cms/user/list-pagination`;
  const payload = {
    filter: { username },
    operatorId: store.state.selectedOperator.operatorId,
    page: 0,
    pageSize: 10,
    sortBy: [["createdAt", -1]],
  };
  return await axios.post(url, payload).then((res) => res.data.result);
};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (__props.type !== 'game')
        ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
            key: 0,
            class: "text-gray-500 cursor-pointer",
            transform: "shrink-2",
            icon: ['fas', 'plus'],
            onClick: _cache[0] || (_cache[0] = ($event: any) => (getUpline(checkNameColumn(__props.data))))
          }))
        : _createCommentVNode("", true),
      _createElementVNode("p", {
        class: _normalizeClass(["text-left w-32 cursor-pointer", __props.type !== 'game' ? 'hover:underline' : '']),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (__props.type !== 'game' ? goToProfile(checkNameColumn(__props.data)) : null))
      }, _toDisplayString(checkNameColumn(__props.data)), 3)
    ]),
    (showUpline.value)
      ? (_openBlock(), _createElementBlock("ul", {
          key: 0,
          class: _normalizeClass(["ml-2 cursor-pointer", upline.value.userId ? ' hover:underline' : 'text-red-500']),
          onClick: _cache[2] || (_cache[2] = 
        () => (upline.value.userId ? _unref(router).push(`/players/${upline.value.userId}`) : null)
      )
        }, [
          _createElementVNode("span", null, _toDisplayString(upline.value.username ? "ref: " + upline.value.username : "ไม่พบข้อมูลหัวสาย"), 1)
        ], 2))
      : _createCommentVNode("", true)
  ]))
}
}

})